module.exports = __webpack_public_path__ + "img/label.bcce86d1.svg";